class ProductPersonalisation extends HTMLElement {
  constructor() {
    super();
    this.personalisation = this.querySelectorAll('.product-form__personalisation');
    this.togglePersonalisation(); 
  }

  togglePersonalisation() {
    var check = false
    const personalisationInput = document.getElementById('personalisation');
    const standardButton = document.querySelector('[name="options[Personalisation]"][value="Standard"]');
    const personalisedButton = document.querySelector('[name="options[Personalisation]"][value="Personalised"]');

    this.personalisation.forEach((personal) => personal.addEventListener('keyup', () => {
      if (personalisationInput) {
        if (personalisationInput.value != '') {
          if (check == false) {
            check = true; 
            personalisedButton.click();
          }
        } else {
          check = false;
          standardButton.click();
        }
      }
    }));
  }
}
customElements.define('product-personalisation', ProductPersonalisation);